import { FormTable } from "@/components/form-table";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/forms",
)({
  component: RouteComponent,
  pendingComponent: () => (
    <div>
      <h1 className="text-2xl font-bold mb-6">Todos los formularios</h1>
      <div className="p-4 border rounded-md flex items-center space-x-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Cargando formularios...</span>
      </div>
    </div>
  ),
});

function RouteComponent() {
  return <FormTable showDepartment={true} title="Todos los formularios" />;
}
